/* Delfino — scan-handoff.js (29.09.2026): trimiterea din „Scanare Unghii AI" spre formularul de comandă.

   Pe pagina de rezultat, butonul „Comandă cu plata la livrare" duce omul pe pagina produsului
   principal din plan, cu tot ce a ales în adresă:

     /products/<handle>?ns=<token scanare>&ns_qty=6&ns_addons=keranail,keratalp&ns_code=SCAN5#dl-cod-form-slot

   Aici, DOAR când adresa are `ns_qty` (orice altă vizită nu atinge nimic):
     1. alege treapta cu aceeași cantitate în erou (click pe rândul `.dl-qb-row`) — sincronizarea
        existentă din product.js (bindOfferSync, cu plasa ei de siguranță) bifează apoi ACEEAȘI ofertă
        în formularul Releasit; fără treaptă în erou, dăm noi click pe oferta din formular;
     2. derulează la formularul Releasit din pagină, după ce a apărut (vine asincron, iar tema îl mută
        în slotul de jos) — o singură dată și doar în primele secunde, ca să nu smulgem pagina de sub
        un om care citește deja;
     3. bifează suplimentele alese (bifele „tick-up" ale Releasit al căror text conține „KeraNail" /
        „KeraTalp"); o bifă care nu există nu e o eroare — nu facem nimic și nu arătăm nimic;
     4. DOAR dacă adresa are un cod (bonusul deblocat cu email / telefon): îl scrie în „Cod de
        reducere" și apasă „Aplică".
   Releasit își re-randează formularul (schimbarea ofertei, relocarea, popup-ul): câteva secunde după
   ce a apărut, o plasă de siguranță verifică o dată pe tură că bifele și codul au rămas — dar NU
   insistă peste om: o bifă schimbată de mâna lui sau un cod tastat de el rămân cum le-a lăsat.

   Ce NU face, niciodată: nu trimite formularul, nu apasă butonul de finalizare, nu atinge numele,
   telefonul, adresa sau orice alt câmp.

   Pâlnia (worker/nail-scan, `POST /action`): `form_opened` când formularul a apărut pe ecran și
   `code_applied` când codul a fost scris + „Aplică" apăsat. Pleacă doar cu tokenul din `?ns=` și cu
   adresa Worker-ului lăsată în browser de scaner (localStorage `ns:worker`); altfel nu pleacă nimic.
   Fiecare o singură dată pe token (același steag de sesiune ca scanerul: `ns:act:<token>`).

   Globala expusă: DLScanHandoff (`parse` e pură și merge și în Node, pentru teste). */
(function (root) {
  'use strict';

  var TOKEN_RE = /^[a-z0-9]{32}$/;
  var CODE_RE = /^[A-Za-z0-9_-]{1,40}$/;
  /* ACEEAȘI listă ca HANDOFF_ADDON_KEYS din nail-scan.js: altceva din adresă nu se bifează. */
  var ADDON_KEYS = ['keranail', 'keratalp'];
  var MAX_QTY = 99;
  var WORKER_KEY = 'ns:worker';
  var ACTIONS_KEY = 'ns:act:';
  var WORKER_URL_RE = /^(https:\/\/[A-Za-z0-9.-]+(:\d{1,5})?|http:\/\/(localhost|127\.0\.0\.1)(:\d{1,5})?)(\/[A-Za-z0-9._~\/-]*)?$/;

  function own(map, key) { return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : undefined; }

  /* Parametrii trimiterii din `location.search`. `null` = nu e o trimitere (fără `ns_qty` valid). */
  function parse(search) {
    var query = String(search || '').replace(/^\?/, '');
    if (!query) return null;
    var params = {};
    query.split('&').forEach(function (pair) {
      if (!pair) return;
      var at = pair.indexOf('=');
      var key = at < 0 ? pair : pair.slice(0, at);
      var value = at < 0 ? '' : pair.slice(at + 1);
      try {
        key = decodeURIComponent(key.replace(/\+/g, ' '));
        value = decodeURIComponent(value.replace(/\+/g, ' '));
      } catch (e) { return; }
      if (own(params, key) === undefined) params[key] = value;
    });
    var rawQty = own(params, 'ns_qty');
    if (typeof rawQty !== 'string' || !/^\d{1,2}$/.test(rawQty)) return null;
    var qty = parseInt(rawQty, 10);
    if (!(qty >= 1 && qty <= MAX_QTY)) return null;
    var token = own(params, 'ns');
    var code = own(params, 'ns_code');
    var addons = [];
    String(own(params, 'ns_addons') || '').split(',').forEach(function (one) {
      var key = one.trim().toLowerCase();
      if (ADDON_KEYS.indexOf(key) > -1 && addons.indexOf(key) < 0) addons.push(key);
    });
    return {
      qty: qty,
      token: typeof token === 'string' && TOKEN_RE.test(token) ? token : '',
      addons: addons,
      code: typeof code === 'string' && CODE_RE.test(code) ? code : ''
    };
  }

  /* Text de comparat: litere mici, fără diacritice, spațiile strânse. */
  function norm(text) {
    var out = String(text || '').toLowerCase();
    try { out = out.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* browser vechi */ }
    return out.replace(/\s+/g, ' ').trim();
  }

  root.DLScanHandoff = { parse: parse, norm: norm, addonKeys: ADDON_KEYS.slice() };

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ===== Partea de DOM ===== */

  var FORM_SEL = '#_rsi-cod-form-modal-form';
  var OFFER_SEL = '._rsi-quantity-offers-offer-container';
  var OFFER_ON = '_rsi-quantity-offers-selected';
  var TICK_SEL = 'input[type="checkbox"][data-tick-ups-visible-checkbox], ._rsi-tick-ups-offer input[type="checkbox"]';
  var CODE_INPUT_SEL = '#_rsi-modal-discounts-form-code';
  var CODE_APPLY_SEL = '#_rsi-modal-discounts-form-apply';
  var PLAQUES_SEL = '._rsi-modal-discounts-plaques';
  /* Butoanele care deschid popup-ul Releasit (modul „popup"): după un click, pornim din nou. */
  var RSI_TRIGGER_SEL = '._rsi-buy-now-button, [class*="_rsi-buy-now"], [data-dl-rsi-hook], [data-dl-order-btn], [data-dl-hero-order]';

  var POLL_MS = 300;
  var WAIT_MS = 30000;      /* cât așteptăm să apară formularul */
  var GUARD_MS = 20000;     /* cât ține plasa de siguranță după ce a apărut */
  var SETTLE_MS = 700;      /* răgazul dintre pași: Releasit re-randează după fiecare click */
  var TIER_WAIT_MS = 5000;  /* peste atât, mergem mai departe chiar dacă oferta n-a ajuns încă pe cantitate */
  var SCROLL_WINDOW_MS = 12000;
  var CODE_RETRY_MS = 2500;
  var MAX_CODE_TRIES = 3;

  function now() { return Date.now(); }

  function visible(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    return !cs || (cs.visibility !== 'hidden' && cs.display !== 'none');
  }

  function inViewport(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.height > 0 && r.top < vh && r.bottom > 0;
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isSubmit(el) {
    if (!el) return true;
    if (String(el.type || '').toLowerCase() === 'submit') return true;
    return !!(el.closest && el.closest('._rsi-build-block-submit-button, ._rsi-buy-now-button'));
  }

  /* Un click care NU poate fi niciodată „trimite comanda". */
  function safeClick(el) {
    if (!el || isSubmit(el) || typeof el.click !== 'function') return false;
    el.click();
    return true;
  }

  function fire(el, type) {
    var ev = null;
    try { ev = new Event(type, { bubbles: true }); } catch (e) {
      try { ev = document.createEvent('Event'); ev.initEvent(type, true, true); } catch (err) { ev = null; }
    }
    if (ev) el.dispatchEvent(ev);
  }

  /* Valoarea prin setterul NATIV: bibliotecile care își țin starea în JS (React & co.) ignoră un
     `input.value = …` simplu, dar văd evenimentul `input` de după setterul prototipului. */
  function setValue(input, value) {
    var desc = null;
    try { desc = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value'); } catch (e) { desc = null; }
    if (desc && typeof desc.set === 'function') desc.set.call(input, value);
    else input.value = value;
    fire(input, 'input');
    fire(input, 'change');
  }

  function session() {
    try { return window.sessionStorage; } catch (e) { return null; }
  }

  function workerBase() {
    var value = '';
    try { value = window.localStorage ? String(window.localStorage.getItem(WORKER_KEY) || '') : ''; } catch (e) { value = ''; }
    return WORKER_URL_RE.test(value) ? value.replace(/\/+$/, '') : '';
  }

  function run(opts) {
    var qty = opts.qty;
    var token = opts.token;
    var addons = opts.addons;
    var code = opts.code;
    var startedAt = now();
    var until = startedAt + WAIT_MS;
    var timer = null;
    var reported = {};
    var s = {
      heroTried: false,
      formSince: 0,
      scrolled: false,
      tierAt: 0,
      lastClickAt: 0,
      codeTries: 0,
      codeAt: 0,
      userCode: false,
      userTicks: {}
    };

    /* ── pâlnia: o dată pe token, fără nimic personal ── */
    function report(name) {
      if (!token || reported[name]) return;
      reported[name] = true;
      var store = session();
      var key = ACTIONS_KEY + token;
      var list = [];
      try { list = String((store && store.getItem(key)) || '').split(',').filter(Boolean); } catch (e) { list = []; }
      if (list.indexOf(name) > -1) return;
      var base = workerBase();
      if (!base || typeof window.fetch !== 'function') return;
      try {
        var req = window.fetch(base + '/action', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token, action: name }),
          keepalive: true,
          credentials: 'omit',
          mode: 'cors'
        });
        if (req && typeof req.catch === 'function') req.catch(function () { /* pâlnia nu strică pagina */ });
      } catch (e) { return; }
      list.push(name);
      try { if (store) store.setItem(key, list.join(',')); } catch (e) { /* stocare blocată */ }
    }

    /* ── 1. treapta din erou ── */
    function heroRow() {
      return document.querySelector('[data-dl-bundles] .dl-qb-row[data-qb-qty="' + qty + '"]');
    }

    function qtyMap() {
      try { return root.DLProduct && typeof root.DLProduct.rsiQtyByPos === 'function' ? root.DLProduct.rsiQtyByPos() : {}; } catch (e) { return {}; }
    }
    function offerQty(el, map) {
      if (root.DLProduct && typeof root.DLProduct.rsiOfferQty === 'function') return root.DLProduct.rsiOfferQty(el, map);
      var m = (el.textContent || '').match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    }
    function matchingOffer(form) {
      var offers = form.querySelectorAll(OFFER_SEL);
      if (!offers.length) return null;
      var map = qtyMap();
      for (var i = 0; i < offers.length; i++) if (offerQty(offers[i], map) === qty) return offers[i];
      return null;
    }
    /* Gata = oferta cu aceeași cantitate e bifată în formular (sau formularul n-are asemenea ofertă). */
    function tierReady(form) {
      var offer = matchingOffer(form);
      return !offer || offer.classList.contains(OFFER_ON);
    }

    /* ── 2. formularul ── */
    function findForm() {
      var forms = document.querySelectorAll(FORM_SEL);
      for (var i = 0; i < forms.length; i++) if (visible(forms[i])) return forms[i];
      return null;
    }
    function embedded(form) {
      return !!(form.closest && form.closest('._rsi-cod-form-embed-container, [data-dl-cod-slot]'));
    }
    function scrollTo(form) {
      var target = (form.closest && form.closest('._rsi-cod-form-embed-container')) || form;
      var header = document.querySelector('[data-dl-header], .dl-header, header');
      var offset = (header ? Math.min(header.getBoundingClientRect().height, 140) : 0) + 12;
      var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
      try { window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, top)); }
    }

    /* ── 3. suplimentele ── */
    function tickKey(box) {
      var label = (box.closest && box.closest('label')) || box.parentElement;
      var text = norm(label ? label.textContent : '');
      for (var i = 0; i < ADDON_KEYS.length; i++) if (text.indexOf(ADDON_KEYS[i]) > -1) return ADDON_KEYS[i];
      return '';
    }
    /* Întoarce true dacă a dat măcar un click (atunci așteptăm să se așeze formularul). */
    function tickAddons(form) {
      if (!addons.length) return false;
      var boxes = form.querySelectorAll(TICK_SEL);
      var clicked = false;
      addons.forEach(function (key) {
        if (s.userTicks[key]) return;
        for (var i = 0; i < boxes.length; i++) {
          if (tickKey(boxes[i]) !== key) continue;
          if (!boxes[i].checked && safeClick(boxes[i])) clicked = true;
          return;
        }
      });
      return clicked;
    }

    /* ── 4. codul ── */
    function codeApplied(form) {
      var plaques = form.querySelector(PLAQUES_SEL);
      return !!(plaques && (plaques.children.length || norm(plaques.textContent)));
    }
    function applyCode(form) {
      var input = form.querySelector(CODE_INPUT_SEL);
      var button = form.querySelector(CODE_APPLY_SEL);
      if (!input || !button || isSubmit(button)) return false;
      setValue(input, code);
      if (!safeClick(button)) return false;
      s.codeTries += 1;
      s.codeAt = now();
      report('code_applied');
      return true;
    }
    function maybeCode(form) {
      if (!code || s.userCode || s.codeTries >= MAX_CODE_TRIES) return;
      if (s.codeTries === 0) { applyCode(form); return; }
      if (codeApplied(form) || now() - s.codeAt < CODE_RETRY_MS) return;
      /* Formularul re-randat a pierdut codul (câmp gol) sau nu l-a luat încă: încă o încercare. */
      var input = form.querySelector(CODE_INPUT_SEL);
      if (input && (input.value === '' || input.value === code)) applyCode(form);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function tick() {
      var t = now();
      if (t > until) { stop(); return; }
      if (!s.heroTried) {
        s.heroTried = true;
        var row = heroRow();
        /* Și pe rândul deja activ: evenimentul `dl:bundle-changed` pornește plasa de siguranță a
           sincronizării din product.js (altfel ea nu știe că „omul" a ales). */
        if (row) row.click();
      }
      var form = findForm();
      if (!form) return;
      if (!s.formSince) {
        s.formSince = t;
        until = Math.max(until, t + GUARD_MS);
      }
      if (!s.scrolled && embedded(form) && t - s.formSince >= SETTLE_MS && t - startedAt <= SCROLL_WINDOW_MS) {
        s.scrolled = true;
        scrollTo(form);
      }
      if (inViewport(form)) report('form_opened');

      if (!s.tierAt) {
        if (!heroRow()) {
          var offer = matchingOffer(form);
          if (offer && !offer.classList.contains(OFFER_ON) && t - s.lastClickAt >= SETTLE_MS && safeClick(offer)) s.lastClickAt = t;
        }
        if (!tierReady(form) && t - s.formSince < TIER_WAIT_MS) return;
        s.tierAt = t;
        return;
      }
      if (t - s.tierAt < SETTLE_MS || t - s.lastClickAt < SETTLE_MS) return;
      if (tickAddons(form)) { s.lastClickAt = t; return; }
      maybeCode(form);
    }

    function kick(ms) {
      until = Math.max(until, now() + ms);
      if (!timer) timer = setInterval(tick, POLL_MS);
    }

    /* Mâna omului are ultimul cuvânt: o bifă de supliment schimbată de el sau un cod tastat de el
       nu mai sunt atinse de plasa de siguranță. Doar evenimentele ADEVĂRATE (`isTrusted`). */
    document.addEventListener('click', function (e) {
      if (!e || !e.isTrusted) return;
      var target = e.target && e.target.closest ? e.target : null;
      if (!target) return;
      var tickLabel = target.closest('._rsi-tick-ups-offer, label');
      var box = target.matches && target.matches('input[type="checkbox"]') ? target : (tickLabel ? tickLabel.querySelector('input[type="checkbox"]') : null);
      if (box && box.closest && box.closest(FORM_SEL)) {
        var key = tickKey(box);
        if (key) s.userTicks[key] = true;
      }
      if (target.closest(CODE_APPLY_SEL + ', ' + CODE_INPUT_SEL + ', ' + PLAQUES_SEL)) s.userCode = true;
      if (target.closest(RSI_TRIGGER_SEL)) kick(10000);
    }, true);
    ['keydown', 'input', 'paste'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (e && e.isTrusted && e.target && e.target.closest && e.target.closest(CODE_INPUT_SEL)) s.userCode = true;
      }, true);
    });

    kick(WAIT_MS);
    tick();
    return { tick: tick, stop: stop, state: s };
  }

  function boot() {
    var opts = null;
    try { opts = parse(window.location.search); } catch (e) { opts = null; }
    if (!opts) return;
    /* După product.js (tot `defer`, încărcat înaintea noastră): rândurile treptelor sunt legate. */
    setTimeout(function () { root.DLScanHandoff.active = run(opts); }, 0);
  }

  /* Ca product.js: scriptul e `defer`, deci rulează ÎNAINTEA lui DOMContentLoaded — atunci leagă
     product.js treptele, iar noi pornim după el. Injectat după încărcare (editorul) → pe loc. */
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})(typeof globalThis !== 'undefined' ? globalThis : this);
